import { render, staticRenderFns } from "./LittleBox.vue?vue&type=template&id=049428ae&scoped=true&"
import script from "./LittleBox.vue?vue&type=script&lang=js&"
export * from "./LittleBox.vue?vue&type=script&lang=js&"
import style0 from "./LittleBox.vue?vue&type=style&index=0&id=049428ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049428ae",
  null
  
)

export default component.exports